import { render, staticRenderFns } from "./AttachmentInput.vue?vue&type=template&id=7e067890&"
import script from "./AttachmentInput.vue?vue&type=script&lang=js&"
export * from "./AttachmentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports